import styled from 'styled-components'
import Text from '../../../../../../text'

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  width: 100%;
  gap: 1.5rem;
`
export const Question = styled.div`
  display: flex;
  flex-direction: column;
`

export const QuestionText = styled(Text)`
  width: 70%;
  word-wrap: break-word;
`
